<template>
  <div
    class="riskNum-wrap"
    @mouseenter="handleInterval('enter')"
    @mouseleave="handleInterval('leave')"
  >
    <Card-border></Card-border>
    <div class="riskNum-top">
      <div class="riskNum-title">检测风险数量变化</div>
      <div class="riskNum-radiobtn">
        <RadioBtn
          :config="DEFAULTCONFIG"
          :activeVal="activeVal"
          @onChange="radioChange"
          :autoChange="true"
          :counter="props.counter"
          ref="radioBtnRef"
        />
      </div>
    </div>
    <div class="riskNum-content">
      <LineChart
        v-if="chartData || chartData.length !== 0"
        :data="chartData"
        :chartIndex="0"
      />
      <a-empty v-else />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { Empty } from "ant-design-vue";
import CardBorder from "@/components/common/card-border.vue";
import LineChart from '../chartComponent/lines-chart.vue';
import RadioBtn from "@/components/common/radio-btn.vue";
export default {
  props: {
    data: Object,
    counter: Number,
  },
  components: {
    CardBorder,
    RadioBtn,
    LineChart,
    Empty
  },

  setup(props) {
    const radioBtnRef = ref(null);
    const DEFAULTCONFIG = [
      {
        label: '漏洞风险',
        value: 'scan'
      },
      {
        label: '隐私合规',
        value: 'compliance'
      }
    ];
    const activeVal = ref(DEFAULTCONFIG[0].value);
    const chartData = ref([]);
    const radioChange = (val) => {
      activeVal.value = val;
      init();
    };
    const init = () => {
      if (props.data) {
        chartData.value = props.data[activeVal.value].map((item) => {
          return {
            ...item,
            name: item.time,
            value: item.total
          };
        });
      }
    };
    const handleInterval = (type) => {
      radioBtnRef.value.handleInterval(type);
    };
    // 监听传值，刷新图表
    watch(props, () => {
      init();
    });
    init();
    return {
      activeVal,
      DEFAULTCONFIG,
      radioChange,
      props,
      chartData,
      radioBtnRef,
      handleInterval
    };
  },
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>